import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

// useQueryString is used to access query string params from window.location

export const useQueryString = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};
